export const COMPANY_FEATURE_LAZY = 'companyFeature';
export const COMPANY_UI_LAZY = 'companyUi';
